import React from 'react'
import { useTranslation } from 'react-i18next'
import OldIcon from 'components/Icon/Icon'
import Text from 'particles/Text'
import RectangleButton from 'particles/Button/RectangleButton'
import { useRedirect } from 'hooks'
import styled from 'styled-components'

interface ExpireLinkProp {
    className?: string
    subtext: string[]
    actionConfig?: {
        label: string
        action: () => void
    }
}

const ExpireLink: React.FC<ExpireLinkProp> = ({ className, subtext, actionConfig }) => {
    const [t] = useTranslation()
    const { redirectToLogin } = useRedirect()

    return (
        <div className={className}>
            <OldIcon.ExpireLinkIcon />
            <Text scale="H2" className="title">
                {t('logIn.linkExpiredHeader')}
            </Text>
            <div>
                {subtext.map((text: string, index: number) => (
                    <>
                        <Text scale="bodyM500" className="subtext" color="secondary" key={index}>
                            {text}
                        </Text>
                    </>
                ))}
            </div>
            {actionConfig && <RectangleButton label={actionConfig.label} size="l" onClick={actionConfig.action} />}
            <RectangleButton
                label={t('button.returnToLogIn')}
                size="l"
                onClick={redirectToLogin}
                form={actionConfig ? 'outlined' : 'filled'}
            />
            <Text scale="caption400" className="copyright">
                {t('logIn.partipostCopyrightFooter')}
            </Text>
        </div>
    )
}

export default styled(ExpireLink)`
    max-width: 480px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    gap: ${({ theme }) => theme.spacing[600]};
    svg,
    .title,
    .subtext {
        align-self: center;
    }
    .subtext {
        width: 100%;
        text-align: center;
    }
    .copyright {
        align-self: center;
    }
`
